var React = require('react');
var objectAssign = require('object-assign');
module.exports = function (props) {
    return React.createElement('svg', objectAssign({}, {
        viewBox: '0 0 16 12',
        version: '1.1'
    }, props), React.createElement('title', null), React.createElement('defs', null), React.createElement('g', {
        id: 'Projects',
        stroke: 'none',
        strokeWidth: '1',
        fill: 'none'
    }, React.createElement('g', {
        id: 'Node-Edit',
        transform: 'translate(-48.000000, -370.000000)',
        stroke: '#000000',
        strokeWidth: '2'
    }, React.createElement('g', {
        id: 'Link-Button',
        transform: 'translate(49.000000, 371.000000)'
    }, React.createElement('path', {
        d: 'M8.057,0 L9.004,0 C11.763,0 14,2.244 14,5 C14,7.761 11.763,10 8.995,10 L8,10',
        id: 'Path'
    }), React.createElement('path', {
        d: 'M0.057,0 L1.004,0 C3.763,0 6,2.244 6,5 C6,7.761 3.763,10 0.995,10 L0,10',
        id: 'Path-Copy',
        transform: 'translate(3.000000, 5.000000) scale(-1, 1) translate(-3.000000, -5.000000) '
    }), React.createElement('path', {
        d: 'M3,5 L11,5',
        id: 'Path'
    })))));
};


//////////////////
// WEBPACK FOOTER
// ./~/react-icon-loader!./app/images/EditorLink.svg
// module id = 523
// module chunks = 1